import { render, staticRenderFns } from "./chakanhuosun.vue?vue&type=template&id=a473f228&scoped=true&"
import script from "./chakanhuosun.vue?vue&type=script&lang=js&"
export * from "./chakanhuosun.vue?vue&type=script&lang=js&"
import style0 from "./chakanhuosun.vue?vue&type=style&index=0&id=a473f228&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a473f228",
  null
  
)

export default component.exports